<script lang="ts" setup>
const { fetchTranslatedDocument } = useTranslation()

const { data: page } = await fetchTranslatedDocument({
  document: '/product/terms',
  fields: [
    'banner',
    'body',
    'description',
    'headline',
    'title',
  ],
  key: 'product-terms',
})

useSeoMeta({
  description: page.value?.description,
  title: page.value?.title,
})
</script>

<template>
  <UContainer class="py-20">
    <UCard>
      <LayoutPageContent
        v-if="page"
        :page="page"
      />
    </UCard>
  </UContainer>
</template>
